import { useState } from 'react';
import './style.css';

const qaItems = [
  {
    question: "מה הגודל של המסגרות?",
    answer: "גודל המסגרות שתוכלו למצוא באתר שלנו הוא 20x20 סמ והעובי הוא 1.5 סמ"
  },
  {
    question: "כמה זמן לוקח לחבילה להגיע?",
    answer: "ההזמנה מגיעה בהתאם לזמנים המופיעים בעגלה בזמן הרכישה, וברוב המקרים נעשה את המיטב כדי שההזמנה תגיע אליכם בתוך 3-7 ימי עסקים"
  },
  {
    question: "מה זה בלנדס?",
    answer: "בלנדס הם תמונות קסומות וממוסגרות שאפשר להניח על הקיר בהדבקה ללא כל צורך במסמרים, רצוי לערבב תמונות מטיולים שונים וחוויות שונות מהחיים וכך ליצור קיר חי ונושם בבית שמספר את סיפור המשפחה."
  },
  {
    question: "איך זה עובד?",
    answer: "תולשים את הכיסוי מפס ההדבקה שמאחורי המסגרת, בוחרים את המיקום הרצוי על הקיר ומניחים את המסגרת"
  },
  {
    question: "אפשר להניח בלנדס על כל סוגי הקירות?",
    answer: "אפשר להדביק ללא חשש את מסגרות בלנדס על רוב סוגי הקירות אך בכל זאת, בקירות שבהם יש נקודות טייח בולטות, תבניות שליכטה (כגון תבניות גשם, טיפות, מברשת וכד') או חוסר עקביות שטחית, לא ניתן ועדיף שלא להדביק על סוגי קירות כאלו את המסגרות."
  }
];

const CommonQuestion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQA = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="cq_accordion_container">
      {qaItems.map((item, index) => (
        <div
          key={index}
          className={`cq_accordion_item ${openIndex === index ? 'open' : ''}`}
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <div
            className="cq_accordion_header"
            onClick={() => toggleQA(index)}
          >
            <span className="cq_accordion_icon">
              {openIndex === index ? '−' : '+'}
            </span>
            <span className="cq_accordion_question">{item.question}</span>
          </div>
          <div className="cq_accordion_content">
            <div className="cq_accordion_answer">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommonQuestion;
